import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { GUID } from '@barthauer/abc/core';
import { DataService as CoreDataService, QueryColumn } from '@barthauer/abc/core/data';
import { Address, DefaultIcons, MailAndWebAddress, PhoneNumber } from '@barthauer/custom/xmt-models';
import { DxButtonModule, DxDataGridModule, DxFormModule, DxPopupModule } from 'devextreme-angular';

import { FlexLayoutModule } from '@angular/flex-layout';
import {
  AbcPopupComponent,
  AbcSpeedDialActionComponent,
  AbcTextBoxComponent,
  _AbcButtonComponent,
  _AbcContextMenuComponent,
  _AbcFormComponent,
  _AbcGridComponent,
  _AbcScrollViewComponent,
} from '@barthauer/abc/ui-components';
import {
  DxContextMenuModule,
  DxDateBoxModule,
  DxSpeedDialActionModule,
  DxTagBoxModule,
  DxTileViewModule,
} from 'devextreme-angular';
import { DxiItemModule } from 'devextreme-angular/ui/nested';
import { locale } from 'devextreme/localization';
import { Column } from 'devextreme/ui/data_grid';
import { forkJoin, Observable, of, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import {  NotificationMessage, PermessionType, ToastType } from '../../models/enumeration-list.model';
import { AppService } from '../../services/app.service';
import { DataService, ObjectKeys } from '../../services/data.service';
import { LanguageService } from '../../services/language.service';
import { NotificationService } from '../../services/notification.service';
import { ObjectTypeNames } from '../../shared/companies/companies.service';
import { FavoritesService } from '../../shared/favorite/favorites.service';
import { SharedModule } from '../../shared/shared.module';
import { AddressViewModel } from '../../view-models/address.view-model';
import { CompanyService } from './company.service';
import { CheckPermissionDirective } from '../../directives/check-permession-directive';
@Component({
  selector: 'ubt-geods-companies-list',
  templateUrl: './companies-list.component.html',
  styleUrls: ['./companies-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FlexLayoutModule,
    DxPopupModule,
    DxTileViewModule,
    DxContextMenuModule,
    DxSpeedDialActionModule,
    DxTagBoxModule,
    SharedModule,
    DxButtonModule,
    DxiItemModule,
    DxDateBoxModule,
    DxFormModule,
    _AbcFormComponent,
    DxDataGridModule,
    _AbcGridComponent,
    AbcPopupComponent,
    AbcSpeedDialActionComponent,
    _AbcScrollViewComponent,
    _AbcButtonComponent,
    _AbcContextMenuComponent,
    CheckPermissionDirective
  ],
  providers: [CompanyService],
})
export class CompaniesListComponent implements OnInit {
  @ViewChild(_AbcScrollViewComponent, { static: true }) scrollView: _AbcScrollViewComponent;
  @ViewChild('formCompanyPopup') formCompanyPopup: AbcPopupComponent;
  @ViewChild('deleteCompanyPopup') deleteCompanyPopup: AbcPopupComponent;
  @ViewChild('form') form: _AbcFormComponent;
  @ViewChild('companyGrid') companyGrid: _AbcGridComponent;
  @ViewChild('emailTextBox') emailTextBox: AbcTextBoxComponent;
  @ViewChild('phoneTextBox') phoneTextBox: AbcTextBoxComponent;
  @ViewChild('faxTextBox') faxTextBox: AbcTextBoxComponent;
  @ViewChild('contextMenu') contextMenu: _AbcContextMenuComponent;

  public companies: AddressViewModel[] = [];
  public company: Address = new Address(null);
  public phoneNumber: PhoneNumber = new PhoneNumber(null);
  public email: MailAndWebAddress = new MailAndWebAddress(null);
  public columns: QueryColumn[] = [];
  public cachedStatus = [];
  public cachedCompaniesTitles: string[] = [];
  public cancelButtonOptions = {
    text: this.dataService.res('Ubt-Button-Cancel'),
    onClick: () => this.closePopup(),
  };
  public columnsHeader: Column[] = [
    {
      caption: this.dataService.res('Ubt-Company-Column-Name'),
      dataField: 'name',
      visibleIndex: 0,
    },
    {
      caption: this.dataService.res('Ubt-Company-Column-Organization'),
      dataField: 'companyTitle',
      visibleIndex: 1,
      lookup: { dataSource: [], displayExpr: 'Description', valueExpr: 'Value' },
    },
    {
      caption: this.dataService.res('Ubt-Company-Column-Match-Code'),
      dataField: 'matchCode',
      visibleIndex: 2,
    },
    {
      caption: this.dataService.res('Ubt-Company-Column-Status'),
      dataField: 'status',
      visibleIndex: 3,
      lookup: { dataSource: this.cachedStatus, displayExpr: 'Description', valueExpr: 'Value' },
    },

    {
      caption: this.dataService.res('Ubt-Company-Column-Street'),
      dataField: 'street',
      visibleIndex: 4,
    },
    {
      caption: this.dataService.res('Ubt-Company-Column-City'),
      dataField: 'city',
      visibleIndex: 5,
    },
    {
      caption: this.dataService.res('Ubt-Company-Column-Zip'),
      dataField: 'zip',
      visibleIndex: 6,
    },
    {
      caption: this.dataService.res('Ubt-Company-Column-Phone'),
      dataField: 'fullNumber',
      visibleIndex: 7,
      visible: false,
    },
    {
      caption: this.dataService.res('Ubt-Company-Column-Email'),
      dataField: 'email',
      visibleIndex: 8,
      visible: false,
    },
    {
      caption: this.dataService.res('Ubt-Company-Column-Customer-Number'),
      dataField: 'customerNumber',
      visibleIndex: 9,
      visible: false,
    },
    {
      type: 'buttons',
      caption: '',
      alignment: 'left',
      dataField: '',
      visibleIndex: 10,
      minWidth: 50,
      width: '50px',
    },
  ];
  public Action=PermessionType
  public noDataText = this.dataService.res('Ubt-No-Data-text');
  private subscriptions: Subscription[] = [];
  private companyId: string;
  public contextMenuItems: any[] = [
    {
      text: this.dataService.res('Ubt-Company-Edit-Company'),
      onClick: (event) => {
        this.openCompanyDetail(event);
      },
    },

    {
      text: this.dataService.res('Ubt-Company-Delete-Company'),
      onClick: (event) => {
        this.openDeleteCompanyDialog(event);
      },
    },
  ];

  public titlegrid = this.dataService.res('Ubt-SubProject-Create-Company');
  private currentLanguage: string | null;
  constructor(
    public dataService: DataService,
    public appService: AppService,
    private coreDataService: CoreDataService,
    public favoritesService: FavoritesService,
    public companyService: CompanyService,
    private cdr: ChangeDetectorRef,
    private notificationService: NotificationService,
    private languageService: LanguageService
  ) {}

  ngOnInit(): void {
    this.appService.showLoader(true);
    this.prepareFormDataSource();
    this.phoneNumber.Type = 0;
  }
  private prepareFormDataSource(): void {
    forkJoin([
      this.dataService.loadListDataSource('Address', 'Status'),
      this.dataService.loadListDataSource('Address', 'CompanyTitle'),
    ]).subscribe((data: any) => {
      this.cachedStatus = data[0].Data;
      this.cachedCompaniesTitles = data[1].Data;
      this.getCompaniesData();
      this.appService.showLoader(false);
    });
  }
  updatedTranslation(value: string) {
    if (value === 'de' || value == null) {
      locale('de');
    } else {
      locale('en');
    }
    let test = this.dataService.res('Ubt-SubProject-Create-Company');
    this.titlegrid = test;

    const captionsDictionary = {
      0: 'Ubt-Company-Column-Name',
      1: 'Ubt-Company-Column-Organization',
      2: 'Ubt-Company-Column-Match-Code',
      3: 'Ubt-Company-Column-Status',
      4: 'Ubt-Company-Column-Street',
      5: 'Ubt-Company-Column-City',
      6: 'Ubt-Company-Column-Zip',
      7: 'Ubt-Company-Column-Phone',
      8: 'Ubt-Company-Column-Email',
      9: 'Ubt-Company-Column-Customer-Number',
    };

    const documentHeader = this.columnsHeader.map((column) => {
      const translationKey = captionsDictionary[column.visibleIndex];
      if (translationKey) {
        const translatedCaption = this.dataService.res(translationKey);
        return {
          ...column,
          caption: translatedCaption,
        };
      }
      return column;
    });

    this.columnsHeader = documentHeader;
    this.cdr.detectChanges();
  }

  public onCellPrepared(e) {
    if (e.rowType === 'data' && e.column.type === 'buttons') {
      e.cellElement.style.cursor = 'pointer';
      e.cellElement.innerHTML = DefaultIcons.CONTEXTMENU;
    }
    if (e.rowType === 'data' && e.columnIndex === 1) {
      e.cellElement.innerText = e.data.companyTitle;
    }
  }

  public onCellClick(e) {
    this.company = e.data.address;
    if (e.rowType === 'data' && e.column.type === 'buttons') {
      this.getCompanyFields(e);
      this.companyService.isUpdating = true;
      if (this.company.Phone) this.formatNumber('Phone');
      if (this.company.Fax) this.formatNumber('Fax');
     
      e.cellElement.className = 'context-menu-icon' + e.rowIndex;
      e.cellElement.innerHTML = this.contextMenu.visible ? DefaultIcons.CLOSE : DefaultIcons.CONTEXTMENU;

      this.contextMenu.target = '.context-menu-icon' + e.rowIndex;
    
      this.contextMenuItems[0].visible=this.dataService.hasPermessionForSpecificModule('Companies',PermessionType.UPDATE)
      this.contextMenuItems[1].visible=this.dataService.hasPermessionForSpecificModule('Companies',PermessionType.DELETE)
      this.contextMenu.instance.show();
    }
  }

  public getCompaniesData() {
    let companyTitles = [];
    this.subscriptions.push(
      this.coreDataService
        .executeReadObjectsQuery(this.companyService.prepareCompanyColumns())
        .subscribe((companies: any) => {
          companies.forEach((company) => {
            const companyData = new AddressViewModel(company);
            if (
              companyData.companyTitle !== null &&
              companyTitles.map((a) => a.Value).indexOf(companyData.companyTitle) === -1
            ) {
              companyTitles.push({ Value: companyData.companyTitle, Description: companyData.companyTitle });
            }
            this.companies.push(companyData);
          });

          this.companyGrid.columns[1].lookup.dataSource = companyTitles;

          this.cdr.markForCheck();
        })
    );
  }

  public validTextBoxStatus(): boolean {
    if (this.emailTextBox.validationStatus !== 'invalid') {
      return true;
    } else return false;
  }

  private formatNumber(field: string) {
    this.company[field] = this.company[field].replace(' (', '');
    this.company[field] = this.company[field].replace(') ', '');
  }

  public openCompanyDialog(): void {
    this.company = new Address(null);
    this.companyService.isUpdating = false;
    if (this.company.Phone) this.formatNumber('Phone');
    if (this.company.Fax) this.formatNumber('Fax');
    this.cancelButtonOptions.text = this.dataService.res('ubt-Button-Cancel');
    this.formCompanyPopup.title = this.dataService.res('Ubt-Company-Title-Create-Company');
    this.formCompanyPopup.instance.show();
  }

  public onCreateCompany(event) {
    event.preventDefault();
    if (this.validTextBoxStatus()) {
      this.companyService
        .persistCompany(this.company as any)
        .pipe(
          switchMap((company) => {
            this.company.Id = company.Id;
            this.companyId = company.Id;
            return this.createMailFaxPhone(company.Id);
          })
        )
        .subscribe(
          (data) => {
            if (this.companyService.isUpdating === false) {
              this.getCompanyById(this.companyId);
            }
            const company = new AddressViewModel(this.company);
            company.email = this.email.Value;
            this.closePopup();
            this.companyGrid.instance.refresh();
            this.cdr.markForCheck();
          },
          (error) => {
            console.error(error);
            this.notificationService.callNotification({
              message: NotificationMessage.Error,
              type: ToastType.ERROR,
            });
          },
          () => {
            this.appService.showLoader(false);
            this.companyGrid.instance.refresh();
            this.cdr.markForCheck();
          }
        );
    }
  }

  private getCompanyById(companyId: string) {
    this.appService.showLoader(true);
    const opath = 'Id=' + "'" + companyId + "'";
    this.subscriptions.push(
      this.coreDataService.executeReadObjectsQuery(this.companyService.prepareCompanyColumns(opath)).subscribe(
        (company: any) => {
          if (Array.isArray(company) && company.length > 0) {
            this.company = company[0];
            this.companies.push(new AddressViewModel(this.company));
            (this.companyGrid.columns[1].lookup.dataSource as Array<{ Value; Description }>).push({
              Value: this.company.CompanyTitle,
              Description: this.company.CompanyTitle,
            });
            this.companyGrid.instance.refresh();
            this.cdr.markForCheck();
          } else {
            this.companies = [];
            this.notificationService.callNotification({
              message: NotificationMessage.Empty,
              type: ToastType.INFO,
            });
          }
        },
        (error) => {
          this.appService.showLoader(false);
          console.error(error);
          this.cdr.markForCheck();
        },
        () => {
          this.cdr.markForCheck();
        }
      )
    );
  }

  private createMailFaxPhone(companyId: string): Observable<any> {
    return forkJoin([this.createUpdatePhoneNumber(companyId), this.createUpdateMail(companyId)]);
  }
  private addCompaniesValidation = {
    validatePhoneNumber(phoneNumber: PhoneNumber): boolean {
      return (
        !!phoneNumber.CountryCode && !!phoneNumber.LocalAreaCode && !!phoneNumber.Mediation && !!phoneNumber.Number
      );
    },
    validateEmail(email: string): boolean {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailRegex.test(email);
    },
  };

  private createUpdatePhoneNumber(companyId: string): Observable<any> {
    if (this.addCompaniesValidation.validatePhoneNumber(this.phoneNumber)) {
      return this.companyService.persistPhoneNumber(this.phoneNumber, companyId, this.phoneNumber.Id);
    } else {
      return of([]);
    }
  }

  private createUpdateMail(companyId: string): Observable<any> {
    if (this.addCompaniesValidation.validateEmail(this.email.Value)) {
      return this.companyService.persistMailAddress(this.email, companyId, this.email.Id);
    } else {
      return of([]);
    }
  }
  public companiesUpdateState(event, state: string, favoriteData?): void {
    let selectedIndex = this.companies.findIndex((company) => company.id === event.row?.data.Id);
    if (state === 'add') {
      const clonedItem = { ...event.row?.data, IsFavorite: 1, BoxDetailId: favoriteData.Id };
      this.companies[selectedIndex] = clonedItem;
    } else {
      const clonedItem = { ...event.row?.data, IsFavorite: 0 };
      this.companies[selectedIndex] = clonedItem;
    }
  }

  public openCompanyDetail(event): void {
    this.cancelButtonOptions.text = this.dataService.res('ubt-Button-Cancel');
    this.formCompanyPopup.title = this.dataService.res('Ubt-Company-Title-Edit-Company');
    this.formCompanyPopup.instance.show();
  }

  private getCompanyFields(event): void {
    this.company = event.row?.data['address'];
    if (this.company['MailAddress']) {
      this.email = new MailAndWebAddress(this.company['MailAddress'][0] as any);
    }
    if (this.company['PhoneNumbers']) {
      this.phoneNumber = this.company['PhoneNumbers'][0];
    }
  }

  public emptyData(): void {
    this.company = new Address(null);
    this.phoneNumber = new PhoneNumber(null);
    this.phoneNumber.Type = 0;
    this.email = new MailAndWebAddress(null);
    this.form.instance.resetValues();
  }

  public openDeleteCompanyDialog(event): void {
    this.deleteCompanyPopup.instance.show();
  }

  public deleteCompany(): void {
    this.subscriptions.push(
      this.dataService.deleteObject(ObjectKeys.ADDRESS, this.company.Id).subscribe(
        () => {
          const index = this.companies.findIndex((item) => item.id === this.company.Id);
          this.companies.splice(index, 1);
        },
        (error) => {
          console.error(error);
        },
        () => {
          this.deleteCompanyPopup.instance.hide();
        }
      )
    );
  }

  public closePopup(): void {
    this.formCompanyPopup?.instance.hide();
    this.deleteCompanyPopup?.instance.hide();
    this.emptyData();
  }

  public addFavorite(event): void {
    console.error('Not implemented yet!');
    this.favoritesService
      .persistFavoriten(GUID.newGUID(), ObjectTypeNames.Company, event.row?.data.Id, event.row?.data.name)
      .subscribe((data) => {
        this.companiesUpdateState(event, 'add', data);
      });
  }

  public deleteFavorite(event): void {
    this.favoritesService.deleteFavoriten(event.row?.data.BoxDetailId);
    this.companiesUpdateState(event, 'delete');
  }
}
